import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const StatusWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
